<template>
  <div class="content-box">
    <!-- TOPBAR -->
    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between px-3 py-2 border-bottom gap-2">
      <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center w-100 mb-2 mb-md-0">
        <h5 class="mb-2 mb-sm-0 mr-sm-4">Configuración de producto tienda</h5>

        <!-- TOGGLE DE VISTA -->
        <div class="d-flex flex-column flex-sm-row w-100 w-sm-auto">
          <button
            type="button"
            class="btn btn-md btn-outline-secondary mb-1 mb-sm-0 rounded-sm-left"
            :class="{ active: vistaActiva === 'producto' }"
            @click="cambiarVista('producto')"
          >
            <i class="fas fa-box mr-1"></i> Por producto
          </button>
          <button
            type="button"
            class="btn btn-md btn-outline-secondary mb-1 mb-sm-0"
            :class="{ active: vistaActiva === 'tienda' }"
            @click="cambiarVista('tienda')"
          >
            <i class="fas fa-store mr-1"></i> Por tienda
          </button>
          <button
            type="button"
            class="btn btn-md btn-outline-secondary rounded-sm-right"
            :class="{ active: vistaActiva === 'masiva' }"
            @click="cambiarVista('masiva')"
          >
            <i class="fas fa-file-excel mr-1"></i> Carga masiva
          </button>
        </div>
      </div>

      <!-- ACCIÓN PRINCIPAL SEGÚN VISTA -->
      <button
        v-if="vistaActiva === 'producto'"
        class="btn btn-primary btn-sm mt-2 mt-md-0 align-self-start align-self-md-center"
        @click="abrirAgregarTienda"
      >
        <i class="fas fa-plus mr-1"></i> Agregar tienda
      </button>
      <!-- <button
        v-else-if="vistaActiva === 'tienda'"
        class="btn btn-primary btn-sm mt-2 mt-md-0 align-self-start align-self-md-center"
        @click="abrirAgregarProducto"
      >
        <i class="fas fa-plus mr-1"></i> Agregar producto
      </button> -->
    </div>
    
    <div class="card px-2 pb-4" > <!-- v-if="productoEncontrado && !cargando" -->
      <div class="card-body" v-if="vistaActiva === 'producto'">
        <ProductoTiendaConfigByProductComponent/>
      </div>
      <div v-else-if="vistaActiva === 'tienda'" class="card-body">
        <ProductoTiendaConfigByTiendaComponent />
      </div>
      <div v-else-if="vistaActiva === 'masiva'" class="card-body">
        <CargaMasivaProductoTiendaComponent />
      </div>
    </div>
  </div>
</template>

<script>

import CargaMasivaProductoTiendaComponent from '@/components/cat/producto-tienda/CargaMasivaProductoTiendaComponent'
import ProductoTiendaConfigByProductComponent from '@/components/cat/producto-tienda/ProductoTiendaConfigByProductComponent'
import ProductoTiendaConfigByTiendaComponent from '@/components/cat/producto-tienda/ProductoTiendaConfigByTiendaComponent'

export default {
  name: 'GestionProductoTiendaComponent',

  components: {
    ProductoTiendaConfigByProductComponent,
    ProductoTiendaConfigByTiendaComponent,
    CargaMasivaProductoTiendaComponent
  },

  data() {
    return {
      vistaActiva: 'producto',
    }
  },

  methods: {
    cambiarVista(vista) {
      this.vistaActiva = vista
    },
    abrirAgregarTienda() {
      // Emite al componente hijo
      this.$root.$emit('pt:agregar-tienda')
    },
    abrirAgregarProducto() {
      this.$root.$emit('pt:agregar-producto')
    },
  }
}
</script>

<style>
</style>